import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonVariant, IconName, IconSize } from '@as/cotopaxi';
export const FiltersMobileButton = ({ onClick, isContentTileLister, text, }) => (_jsx(Button, { onClick: onClick, iconRight: !isContentTileLister
        ? {
            name: IconName.FILTER_NEW,
            size: IconSize.MEDIUM,
        }
        : undefined, variant: isContentTileLister ? ButtonVariant.BASE : ButtonVariant.OUTLINED, noBubble: true, fill: true, text: text }));
